import Resource from '@/plugins/sdk/Resource'
import { BOOLEAN, DATETIME, STRING, UUID, DATE, TIME, NUMBER, ITEM, COLLECTION } from '@/plugins/sdk/fields'
import Account from '@/plugins/sdk/resources/Account'
import Team from '@/plugins/sdk/resources/Team'
import Profile from '@/plugins/sdk/resources/Profile'
import Carrier from '@/plugins/sdk/resources/Carrier'
import CarrierService from '@/plugins/sdk/resources/Carrier/Service'
import Address from '@/plugins/sdk/resources/Address'
import Event from '@/plugins/sdk/resources/Pickup/Event'
import Note from '@/plugins/sdk/resources/Note'
import Consignment from '@/plugins/sdk/resources/Consignment'
import Item from '@/plugins/sdk/resources/Pickup/Item'
import TimeZone from '@/plugins/sdk/resources/TimeZone'
import Notification from '@/plugins/sdk/resources/Pickup/Notification'

export const TYPE_PERMANENT = 'permanent'
export const TYPE_AUTO = 'auto'
export const TYPE_ADHOC = 'adhoc'
export const TYPE_SCHEDULED = 'scheduled'
export const TYPE_RESERVED = 'reserved'

export const STATUS_LEGACY = 'shipper'
export const STATUS_HIDDEN = 'hidden'
export const STATUS_CANCELLED = 'cancelled'
export const STATUS_HELD = 'held'
export const STATUS_ERROR = 'error'
export const STATUS_PENDING = 'pending'
export const STATUS_PROCESSING = 'processing'
export const STATUS_PROCESSED = 'processed'
export const STATUS_CONFIRMED = 'confirmed'
export const STATUS_REBOOKED = 're-booked'

export default class extends Resource {
  static name = 'pickup'

  static get fields () {
    return {
      id: new UUID(),
      collection_name: new STRING(),
      special_instructions: new STRING(),
      cost_centre: new STRING(),
      charge_account: new STRING(),
      booking_reference: new STRING(),
      customer_reference: new STRING(),
      carrier_reference: new STRING(),
      carrier_response: new STRING(),
      caller_name: new STRING(),
      caller_phone: new STRING(),
      customer_pickup_date: new DATE(),
      customer_closing_time: new TIME(),
      customer_ready_time: new TIME(),
      carrier_cut_off_time: new TIME(),
      items_largest_length: new NUMBER(),
      items_total_weight: new NUMBER(),
      items_have_dg: new BOOLEAN(),
      type: new STRING(),
      status: new STRING(),
      internal_notes: new STRING(),
      created_at: new DATETIME(),
      updated_at: new DATETIME(),
      deleted_at: new DATETIME(),
      previous_pickup: new ITEM(this),
      is_forced: new BOOLEAN(),
      account: new ITEM(Account),
      team: new ITEM(Team),
      profile: new ITEM(Profile),
      carrier: new ITEM(Carrier),
      carrier_service: new ITEM(CarrierService),
      sender: new ITEM(Address),
      receiver: new ITEM(Address),
      events: new COLLECTION(Event),
      notes: new COLLECTION(Note),
      consignments: new COLLECTION(Consignment),
      items: new COLLECTION(Item),
      customer_time_zone: new ITEM(TimeZone),
      notification: new ITEM(Notification)
    }
  }

  static get sortables () {
    return [
      { field: 'collection_name', label: 'Collection Name' },
      { field: 'customer_pickup_date', label: 'Customer Pickup Date' },
      { field: 'customer_closing_time', label: 'Customer Closing Time' },
      { field: 'customer_ready_time', label: 'Customer Ready Time' },
      { field: 'carrier_cut_off_time', label: 'Carrier Cut Off Time' },
      { field: 'created_at', label: 'Created Date' },
      { field: 'updated_at', label: 'Updated Date' },
      { field: 'account.account_name', label: 'Account Name' },
      { field: 'team.team_name', label: 'Team Name' },
      { field: 'profile.profile_name', label: 'Profile Name' },
      { field: 'carrier.carrier_name', label: 'Carrier Name' },
      { field: 'carrier_service.service_name', label: 'Carrier Service Name' },
      { field: 'sender.address_1', label: 'Sender Address' },
      { field: 'receiver.address_1', label: 'Receiver Address' }
    ]
  }
}
